import { Button, Icon, Text } from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { getNposValue } from '../../../../redux/selectors';
import { getFilterClassName } from '../nposUtils';

import { CaretDownIcon, CaretUpIcon } from './icons';

const FILTER_TEXT_LEN = 20;

function Filter({
 label, open, setOpen, isError, isFilterApplied, filterId, afterSlot
}) {
  const { openFilter } = useSelector(getNposValue);

  return (
    <Button
      disableRipple
      afterSlot={afterSlot || (open ? <CaretUpIcon /> : <CaretDownIcon />)}
      beforeSlot={isError ? <Icon className="text-color-error" name="AlertCircleFilled" size="m" /> : <></>}
      className={getFilterClassName(filterId, openFilter, isFilterApplied, open)}
      data-testid={`filter-${filterId}`}
      style={{ minWidth: 'max-content' }}
      variant="secondary"
      onClick={() => setOpen(!open)}
    >
      <Text className="eds-type--subtitle-1">{label?.length > FILTER_TEXT_LEN ? `${label?.substring(0, FILTER_TEXT_LEN)}...` : label}</Text>
    </Button>
  );
}

Filter.defaultProps = {
  afterSlot: null,
  isError: false,
  isFilterApplied: false,
  label: '',
};

Filter.propTypes = {
  afterSlot: PropTypes.node,
  filterId: PropTypes.string.isRequired,
  isError: PropTypes.bool,
  isFilterApplied: PropTypes.bool,
  label: PropTypes.string,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default Filter;
